import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from './Button';

export interface ClearFiltersButtonProps {
  /** Whether anything is narrowing the list right now — a search, a filter. */
  isActive: boolean;
  onClear: () => void;
  className?: string;
}

/**
 * Puts a list back to everything, in one press.
 *
 * Sits at the end of a filter bar. Drawn in the danger tone only while there is
 * something to clear, and disabled otherwise, so it doubles as the sign that
 * the rows below are not the whole list.
 */
export function ClearFiltersButton({ isActive, onClear, className }: ClearFiltersButtonProps) {
  return (
    <Button
      variant={isActive ? 'dangerSoft' : 'secondary'}
      size="sm"
      disabled={!isActive}
      aria-label="Clear search and filters"
      leftIcon={<X className="h-3.5 w-3.5" aria-hidden />}
      onClick={onClear}
      className={cn('h-9 shrink-0 px-2.5 text-xs font-semibold', className)}
    >
      Clear
    </Button>
  );
}
